import React, { useEffect, useState } from "react";
import "./ProfileHeader.css";

const ProfileHeader = () => {
  const [role, setRole] = useState("");

  useEffect(() => {
    try {
      const sessionStored = sessionStorage.getItem("currentUser");
      if (sessionStored) {
        const user = JSON.parse(sessionStored);
        setRole(user.role);
      }
    } catch (e) {
      console.error("Error parsing role in ProfileHeader", e);
    }
  }, []);

  return (
    <div className="profile-header">
      <h1>Waste Watch</h1>
      <div className={`header-underline ${role}`}></div>
    </div>
  );
};

export default ProfileHeader;
